import { createEffectHook } from '../factories/createEffectHook'
import { TypedEvent } from '../models/TypedEvent'

import type { TypedNode } from '../models/TypedNode'

export interface TypedNodeEventConstructor {
  new (...args: any[]): TypedEvent<TypedNode>
}

/**
 * TypedNode 被添加至指定 Store 的主树时触发
 */
export class AddNodeEvent extends TypedEvent<TypedNode> {
  type = 'onAddNode' as const
}

/**
 * TypedNode 位置发生变化时触发
 */
export class MoveNodeEvent extends TypedEvent<TypedNode> {
  type = 'onMoveNode' as const
}

/**
 * TypedNode 从主树子节点变为游离节点时触发
 */
export class RemoveNodeEvent extends TypedEvent<TypedNode> {
  type = 'onRemoveNode' as const
}

export const { onAddNode, onAddNodeCapture } = createEffectHook(AddNodeEvent)
export const { onMoveNode, onMoveNodeCapture } = createEffectHook(MoveNodeEvent)
export const { onRemoveNode, onRemoveNodeCapture } =
  createEffectHook(RemoveNodeEvent)

declare global {
  export interface RehajeTypedEvents {
    onAddNode: AddNodeEvent
    onMoveNode: MoveNodeEvent
    onRemoveNode: RemoveNodeEvent
  }
}
